module.exports = __webpack_public_path__ + "img/bellifuori.21387a7b.png";